/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Generic color options
 * @export
 */
export const GenericColors = {
    /**
    * Primary color
    */
    Primary: 'primary',
    /**
    * Secondary color
    */
    Secondary: 'secondary',
    /**
    * Green color
    */
    Green: 'green',
    /**
    * Blue color
    */
    Blue: 'blue',
    /**
    * Orange color
    */
    Orange: 'orange',
    /**
    * Purple color
    */
    Purple: 'purple',
    /**
    * Yellow color
    */
    Yellow: 'yellow',
    /**
    * Pink color
    */
    Pink: 'pink',
    /**
    * Red color
    */
    Red: 'red',
    /**
    * Gray color
    */
    Gray: 'gray'
} as const;
export type GenericColors = typeof GenericColors[keyof typeof GenericColors];


export function instanceOfGenericColors(value: any): boolean {
    for (const key in GenericColors) {
        if (Object.prototype.hasOwnProperty.call(GenericColors, key)) {
            if (GenericColors[key as keyof typeof GenericColors] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GenericColorsFromJSON(json: any): GenericColors {
    return GenericColorsFromJSONTyped(json, false);
}

export function GenericColorsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenericColors {
    return json as GenericColors;
}

export function GenericColorsToJSON(value?: GenericColors | null): any {
    return value as any;
}

export function GenericColorsToJSONTyped(value: any, ignoreDiscriminator: boolean): GenericColors {
    return value as GenericColors;
}

